import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line connect-dot-com-ui/no-styled-components-imports
import * as styledComponents from 'styled-components';
import * as colors from 'HubStyleTokens/colors';
import * as sizes from 'HubStyleTokens/sizes';
export const theme = {
  colors,
  sizes
};
const {
  default: styled,
  css,
  createGlobalStyle,
  ThemeProvider: StyledComponentsThemeProvider,
  ThemeConsumer,
  keyframes
} = styledComponents;

const ThemeProvider = ({
  children
}) => /*#__PURE__*/_jsx(StyledComponentsThemeProvider, {
  theme: theme,
  children: children
});

export { css, createGlobalStyle, keyframes, ThemeProvider, ThemeConsumer };
export default styled;